import { Megaphone, Sparkles } from "lucide-react";

/**
 * One-line live-data notice shown on the marketing landing page, the user-app
 * dashboard, and anywhere else a NeetOne surface needs to tell the visitor
 * what state coverage is live right now.
 *
 * Pure presentation — no state, no API calls, so it can be dropped into any
 * layout without worrying about auth or data boundaries.
 */
export const DataAvailabilityBanner = ({ tone = "amber", className = "" }) => {
  const palette =
    tone === "dark"
      ? "border-amber-400/40 bg-amber-400/10 text-amber-100"
      : tone === "info"
        ? "border-blue-200 bg-blue-50 text-blue-900"
        : "border-amber-300 bg-amber-50 text-amber-900";
  return (
    <div
      data-testid="data-availability-banner"
      role="status"
      className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border px-4 py-2 text-center text-xs font-medium leading-snug sm:text-sm ${palette} ${className}`}
    >
      <Megaphone className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        <strong className="font-semibold">Karnataka — KEA data is live for your reference.</strong>{" "}
        <span className="opacity-80">MCC and other state counselling data coming soon.</span>
      </span>
      <Sparkles className="hidden h-3.5 w-3.5 shrink-0 opacity-70 sm:inline" aria-hidden />
    </div>
  );
};
